// Mobile menu
document.addEventListener('click', ({ target }) => {
  if (!target.classList.contains('hamburger')) return false;
  target.classList.toggle('is-active');
  document.querySelector('body').classList.toggle('nav__padding-top');
  document.querySelector('.nav').classList.toggle('nav--active');
});

// Mobile submenu
// document.addEventListener('click', ({ target }) => {
//   if (!target.classList.contains('menu-item-has-children') && !target.parentElement.classList.contains('menu-item-has-children')) return false;
//
//   let el;
//
//   if (target.classList.contains('menu-item-has-children')) {
//     el = target;
//   } else if (target.parentElement.classList.contains('menu-item-has-children')) {
//     el = target.parentElement;
//   }
//
//   el.classList[el.classList.contains('menu-item-has-children--active') ? 'remove' : 'add']('menu-item-has-children--active');
// });
